import type {SvgIconInfo} from 'swayok-react-mdb-ui-kit/types/Common'

// Todo: delete iconAdsList?
export const iconAdsList: SvgIconInfo = {
    width: 19.378,
    height: 13.184,
    coloredBy: 'stroke',
    content: `
        <path d="M5.495.5h11.383s2 0 2 2v8.179s0 2-2 2H5.495s-2 0-2-2V2.5s0-2 2-2"/>
        <path d="M6.475 12.681h-4.03a1.891 1.891 0 0 1-1.487-.685 2.373 2.373 0 0 1-.454-1.416V2.001h3.243m3.312 1.063h2.487s1 0 1 1v2.487s0 1-1 1H7.059s-1 0-1-1V4.064s0-1 1-1"/>
        <path stroke-linecap="round" d="M12.397 3.065h4.243M12.397 4.56h4.243m-4.243 1.495h4.243m-4.243 1.496h4.243M6.181 9.047h4.365m-4.365 1.282h4.365"/>
    `,
}

export const iconBankCard: SvgIconInfo = {
    width: 39,
    height: 27,
    coloredBy: 'stroke',
    content: `
        <rect width="37" height="25" x="1" y="1" rx="3" stroke-width="2"/>
        <rect width="39" height="1" x="0" y="9" stroke-width="6"/>
        <rect width="12" height="7" x="5.5" y="15.5" rx=".5"/>
        <path stroke-linecap="round" d="M20.743 16.346h13.316m-13.316 2.38h9.649"/>
    `,
}

// Todo: delete iconDongCoins?
export const iconDongCoins: SvgIconInfo = {
    width: 23.4,
    height: 16.6,
    coloredBy: 'various',
    content: `
        <circle cx="16.784" cy="8.843" r="6.094" fill="#fff" stroke="#000"/>
        <circle cx="8.287" cy="8.287" r="7.787" fill="#fff" stroke="#000"/>
        <circle cx="8.288" cy="8.287" r="5.756" fill="#fff" stroke="#000"/>
        <path stroke="none" transform="translate(.5,.5)" fill="#000" d="M8.977 9.439H8.32v-.426h-.012a.824.824 0 0 1-.408.392 1.381 1.381 0 0 1-.566.119 1.5 1.5 0 0 1-.651-.131 1.292 1.292 0 0 1-.455-.355 1.523 1.523 0 0 1-.274-.53 2.308 2.308 0 0 1-.091-.66 2.109 2.109 0 0 1 .12-.74 1.474 1.474 0 0 1 .3-.51 1.188 1.188 0 0 1 .438-.3 1.393 1.393 0 0 1 .5-.094 1.681 1.681 0 0 1 .3.027 1.313 1.313 0 0 1 .292.088 1.151 1.151 0 0 1 .259.155.86.86 0 0 1 .2.222h.011v-.815h-.93v-.4h.93v-.4h.693v.4h.481v.4h-.48ZM6.556 7.9a1.534 1.534 0 0 0 .052.4 1.084 1.084 0 0 0 .158.347.8.8 0 0 0 .271.243.789.789 0 0 0 .389.091.779.779 0 0 0 .4-.1.826.826 0 0 0 .274-.255 1.155 1.155 0 0 0 .158-.356 1.592 1.592 0 0 0 .052-.4 1.271 1.271 0 0 0-.234-.815.772.772 0 0 0-.636-.292.785.785 0 0 0-.411.1.844.844 0 0 0-.274.262 1.086 1.086 0 0 0-.152.365 1.9 1.9 0 0 0-.047.41Zm-.614 2.573v-.62h3.066v.62Z"/>
    `,
}

// Todo: delete iconWallet?
export const iconWallet: SvgIconInfo = {
    width: 16.716,
    height: 13.944,
    coloredBy: 'stroke',
    content: `
        <path stroke-linecap="round" d="M16.195 9.353v1.842a2.249 2.249 0 0 1-.519 1.676 2.511 2.511 0 0 1-1.838.556H3.122a2.613 2.613 0 0 1-1.9-.715 2.6 2.6 0 0 1-.7-1.693v-6.3a2.69 2.69 0 0 1 .7-1.817 2.8 2.8 0 0 1 1.949-.626h10.651a2.9 2.9 0 0 1 1.851.626 2.06 2.06 0 0 1 .519 1.538v1.8 M.534 5.07a8.186 8.186 0 0 1 .312-3.4A2.477 2.477 0 0 1 3.061.496H15.81 M16.061 5.384h-5.568a1.849 1.849 0 0 0-1.353.46 1.9 1.9 0 0 0-.541 1.164v1.706a1.722 1.722 0 0 0 .541 1.293 2.34 2.34 0 0 0 1.353.475h5.822"/>
        <circle cx="11.492" cy="7.997" r=".77"/>
    `,
}

export const iconStar: SvgIconInfo = {
    width: 17,
    height: 17,
    coloredBy: 'fill',
    content: `
        <path d="M8.5,0l2.975,5.092L17,6.493l-3.686,4.548L13.753,17,8.5,14.719,3.247,17l.44-5.958L0,6.493l5.525-1.4Z"/>
    `,
}

export const iconProfile: SvgIconInfo = {
    width: 24,
    height: 24,
    coloredBy: 'various',
    content: `
        <circle cx="12" cy="12" r="10" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="2"/>
        <path fill="#000" d="M12,5.1c2.2,0,3.8,2,3.3,4.2c-0.3,1.2-1.3,2.2-2.5,2.5c-2.2,0.5-4.2-1.2-4.2-3.3C8.6,6.6,10.1,5.1,12,5.1 M12,13.5 c3.3,0,7.4,1.7,7.5,3.7c0.1,1.8-3.2,3.5-5.4,4.1c-2.2,0.5-3.9,0.1-4.7-0.1c-1.8-0.5-5-2.1-4.9-3.9C4.6,15.2,8.6,13.5,12,13.5z"/>
    `,
}

// Todo: delete iconHelp?
export const iconHelp: SvgIconInfo = {
    width: 800,
    height: 800,
    coloredBy: 'various',
    content: `
        <path fill="#000" d="M370.7,570.7c0-16.2,13.1-29.3,29.3-29.3c16.2,0,29.3,13.1,29.3,29.3c0,0,0,0,0,0c0,16.2-13.1,29.3-29.3,29.3 C383.8,600,370.7,586.9,370.7,570.7z M400,200c-65.3,0.1-118.3,53-118.3,118.4h48.8c0-38.3,31.2-69.6,69.6-69.6s69.6,31.2,69.6,69.6 c0,26.3-21.7,52.6-50,64.1h-0.1c-25.9,10.7-43.8,36.1-43.8,65.8v44.3h48.8v-44.3c0-9.5,5.6-17.3,13.6-20.6 c40.4-16.5,80.4-57.2,80.4-109.3C518.3,253,465.4,200.1,400,200L400,200z"/>
        <circle cx="400" cy="400" r="350" fill="none" stroke="#000" stroke-width="50" stroke-miterlimit="10"/>
    `,
}
